import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import EstoqueIcon from "../../assets/icons/estoque.png";
import EstoquesService from "../../services/EstoqueService";
import ProdutosService from "../../services/ProdutosService";
import formEstoqueDTO from "../../types/FormEstoqueDTO";

export default function EstoquesForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const [form, setForm] = useState({
    idEstoque: null,
    codEstoque: "",
    estoque: "",
    idProduto: "",
    produto: "",
    quantidade: "",
    dataMovimentacao: "",
    tipoMovimentacao: "",
    origem: "",
    observacoes: ""   
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE");
  const [produtos, setProdutos] = useState([]);

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idEstoque: null,
        codEstoque: "",
        estoque: "",
        idProduto: "",
        produto: "",
        quantidade: "",
        dataMovimentacao: "",
        tipoMovimentacao: "",
        origem: "",
        observacoes: ""
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idEstoque: itemSelecionado.IDESTOQUE,
        codEstoque: itemSelecionado.CODESTOQUE,
        estoque: itemSelecionado.ESTOQUE,
        idProduto: itemSelecionado.IDPRODUTO,
        produto: itemSelecionado.DESCRICAO,
        quantidade: itemSelecionado.QUANTIDADE,
        dataMovimentacao: itemSelecionado.DATA_MOVIMENTACAO,
        tipoMovimentacao: itemSelecionado.TIPOMOVIMENTACAO,
        origem: itemSelecionado.ORIGEM,
        observacoes: itemSelecionado.OBSERVACOES
      });
    }
  }, [modo, itemSelecionado]);


  useEffect(() => {
    async function carregarProdutos() {
      const data = await ProdutosService.getAll();
      setProdutos(data || []);
    }

    carregarProdutos();
  }, []);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value,
    });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};
    if (!form.idProduto) e.idProduto = "Informe o produto";
    if (!form.quantidade) e.quantidade = "Informe a quantidade";
    if (!form.dataMovimentacao) e.dataMovimentacao = "Informe a data";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);

    if (Object.keys(validation).length) return;

    setLoading(true);
    setSubmitState("IDLE");

    try {
      const payload = formEstoqueDTO({
        CODESTOQUE: 1,
        ESTOQUE: "PADRÃO",
        IDPRODUTO: Number(form.idProduto),
        QUANTIDADE: Number(form.quantidade),
        DATA_MOVIMENTACAO: form.dataMovimentacao,
        TIPOMOVIMENTACAO: form.tipoMovimentacao,
        ORIGEM: form.origem,
        OBSERVACOES: form.observacoes
      });

      if (modo === "novo") {
        await EstoquesService.create(payload);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Movimentação de estoque criada com sucesso!",
        });
      }

      if (modo === "alterar") {
        await EstoquesService.update(form.idEstoque, payload);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Movimentação de estoque atualizada com sucesso!",
        });
      }

      setSubmitState("SUCCESS");
      onClose();
    } catch (error) {
      onClose();
      setRetorno({
        tipo: "erro",
        mensagem:
          modo === "novo"
            ? "Erro ao criar movimentação de estoque."
            : "Erro ao atualizar movimentação de estoque.",
      });

      setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={EstoqueIcon} alt="" className="icon" />
          {modo === "novo"
            ? "Movimentação de Estoque"
            : "Alterar Movimentação de Estoque"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Estoque *</div>
           <input placeholder="Padrão" value={form.estoque} disabled />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Produto *</div>

          <select
            name="idProduto"
            value={form.idProduto}
            onChange={handleChange}
            disabled={modo === "alterar"}
          >
            <option value="">Selecione</option>

            {produtos.map(p => (
              <option key={p.IDPRODUTO} value={p.IDPRODUTO}>
                {p.DESCRICAO}
              </option>
            ))}
          </select>

          {errors.idProduto && (
            <span style={{ color: "red" }}>{errors.idProduto}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Quantidade *</div>
          <input
            type="number"
            name="quantidade"
            value={form.quantidade}
            onChange={handleChange}
            disabled={modo === "alterar"}
          />
          {errors.quantidade && <span style={{ color: "red" }}>{errors.quantidade}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Data *</div>
          <input
            type="date"
            name="dataMovimentacao"
            value={form.dataMovimentacao}
            onChange={handleChange}
          />
          {errors.dataMovimentacao && (
            <span style={{ color: "red" }}>{errors.dataMovimentacao}</span>
          )}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Tipo</div>
          <select
            name="tipoMovimentacao"
            value={form.tipoMovimentacao}
            onChange={handleChange}
            disabled={modo === "alterar"}
          >
            <option value="E">Entrada</option>
            <option value="S">Saída</option>
            <option value="D">Devolução</option>
            <option value="T">Troca</option>
          </select>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">N° NF/Cupom</div>
          <input name="origem" value={form.origem} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Observações</div>
          <textarea name="observacoes" value={form.observacoes} onChange={handleChange} />
        </div>

        <div className="Form-Interno-alinhamento-button">
          {modo === "novo" && (
            <button type="submit" disabled={loading} className="Form-Interno-button">
              {loading ? "Enviando..." : "Salvar"}
            </button>
            )}

            {modo === "alterar" && (
                <div /*type="submit" disabled={loading}*/
                  title="Não é possível alterar Movimentação de estoque, Gere outra movimentação de ajuste de saldo."
                  className="Form-Interno-alinhamento-button-inativo" >
                  {/*loading ? "Enviando..." : "Salvar"*/}
                  <Link to="/Gerenciamento">Inativo</Link>
  
                </div>
            )}

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
